<template>
    <div>
        <slot :manual-link="manualLink"></slot>
    </div>
</template>

<script>

export default {
    name: 'SupplyManual',
    computed: {
        manualLink() {
            if (this.$i18n.locale === 'ko' && this.ko_manual_url) {
                return this.ko_manual_url;
            } else if (this.$i18n.locale === 'en' && this.en_manual_url) {
                return this.en_manual_url;
            }
            return this.ko_manual_url;
        },
        ko_manual_url() {
            return '/document/manual/2026 QESG 공급망 SAQ 평가 시스템 사용 매뉴얼(Ko).pdf';
        },
        en_manual_url() {
            return '/document/manual/2026 QESG Supply Chain SAQ Assessment System User Manual.pdf';
        },
    },
};
</script>
